<template>
  <Shop v-bind="$attrs">
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </Shop>
</template>

<script>
import Shop from './Shop'
import './fa'

export default {
  provide() {
    return {
      accessToken: this.accessToken,
    }
  },
  computed: {
    accessToken() {
      let params = new URLSearchParams(window.location.search)
      return params.get('accessToken')
    },
  },
  components: {
    Shop,
  },
}
</script>

<style lang="scss"></style>
